import { useEffect, useState, useRef } from "react";
import isVimeoLink from "../utils/isVimeoLink";
import { isYoutubeURL } from "../../../wp-utils/v1";
import Video from "./Video";
import Youtube from "./Youtube";
import Vimeo from "./Vimeo";

const PlaylistVideoPlayer = ({ video, options, player, setPlayer }) => {
  const { video_source, h5vp_video_source, video_thumb, video_title, h5vp_video_provider } = video;
  const [type, setType] = useState(null);
  // const [player, setPlayer] = useState(null);
  const [shouldPlay, setShouldPlay] = useState(false);

  const ref = useRef();

  useEffect(() => {
    if (player) {
      // if (type === h5vp_video_provider) {
      const source = { src: h5vp_video_provider === "library" ? video_source : h5vp_video_source };

      if (h5vp_video_provider === "library") {
        source.type = "video/mp4";
      } else {
        source.provider = h5vp_video_provider;
      }
      player.source = {
        type: "video",
        sources: [source],
      };
      if (shouldPlay) {
        player?.on("ready", () => {
          player.play();
        });
      }
    } else {
      const otherPlayers = document.querySelectorAll(`#player_library, #player_youtube, #player_vimeo`);
      otherPlayers.forEach((player) => {
        player.classList.add("hidden");
      });
      const media = ref.current?.querySelector(`#player_${h5vp_video_provider}`);
      if (media) {
        media.classList.remove("hidden");
        const player = new Plyr(media, options);
        setPlayer(player);
        setShouldPlay(true);
      }
    }
  }, [video]);

  useEffect(() => {
    player?.on("ready", () => {
      ref.current?.parentNode?.parentNode?.classList.add("playlist_loaded");
    });
  }, [player]);

  // console.log(video);

  return (
    <div className="video__main" ref={ref}>
      <div className="video__thumb video__thumb--big mb-1">
        {/* <img className="w-100" src={video_thumb} alt="video" /> */}

        <Video
          style={{ aspectRatio: "16/9" }}
          id={`player_library`}
          // className={h5vp_video_provider === "library" ? "" : "hidden"}
          data-poster={video_thumb}
          qualities={[]}
          captions={[]}
          source={video_source}
          src={video_source}
          isPremium={true}
        />

        {<Youtube id={`player_youtube`} source={isYoutubeURL(h5vp_video_source)} data-poster={video_thumb} />}
        {<Vimeo id={`player_vimeo`} source={isVimeoLink(h5vp_video_source)} data-poster={video_thumb} />}
      </div>
      {/* <h2 className="video-block__title   mb-1">{video_title}</h2>
      <div className="video__uploader">
        <div className="video__uploader__image ">
          <img src="http://localhost/freemius/wp-content/uploads/2023/11/image-analysis.png" alt="user" />
        </div>
        <div className="video__uploader__sub">
          <span>SOMOY TV Bulletin</span>
        </div>
      </div> */}
    </div>
  );
};

export default PlaylistVideoPlayer;
